import * as PIXI from 'pixi.js';
import extendPIXI from './pixijs_enhance.js';
import nipplejs from 'nipplejs';
import TWEEN from '@tweenjs/tween.js';

extendPIXI(PIXI);

PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;

function Game() {
	Game.pixi_load_assets(this);
	if (Game.isfirstplay) {
		Game.isfirstplay = false;
		if (this.onfirstplay)
			this.onfirstplay();
	}
}

Game.prototype.onloaded = Game.start;
Game.prototype.onfirstplay = null;
Game.loadingprogress = null;

Game.pixi_assets_loaded = false;
Game.pixi_loader = PIXI.Loader.shared;

Game.ismuted = false;
Game.isfirstplay = true;

Game.MAPSIZE = 300;

Game.pixi_load_assets = function(game = null) {
	if (!Game.pixi_assets_loaded) {
		Game.pixi_loader.onProgress.add(() => {
			document.getElementById('loading').innerText = `Loading... ${Game.pixi_loader.progress}%`;
			if (Game.loadingprogress)
				Game.loadingprogress(Game.pixi_loader.progress);
		});
		Game.pixi_loader.add([
			'assets/player_character.png',
			'assets/player_character_1.png',
			'assets/bottle.png',
			'assets/survival_icon.png',
		]).load(() => {
			Game.pixi_assets_loaded = true;
			if (game) {
				game.onloaded();
			}
			else {
				document.getElementById('play-button').disabled = false;
				document.getElementById('loading').style.visibility = 'hidden';
			}
		});
	} else if (game)
		game.start();
};

Game.prototype.start = function() {
	document.getElementById('main').style.display = 'none';

	this.app = new PIXI.Application();
	//this.app = new PIXI.Application({width: 800, height: 600});
	document.body.appendChild(this.app.view);
	this.app.view.addEventListener('contextmenu', function (event) {
		event.preventDefault();
	});

	//this.app.renderer.view.style.position = 'absolute';
	//this.app.renderer.view.style.display = 'block';
	//this.app.renderer.autoDensity = true;
	//this.app.renderer.resize(window.innerWidth, window.innerHeight);
	//window.addEventListener('resize', () => {
	//	const ratio = Math.min(window.innerWidth / 800, window.innerHeight / 600);
	//	this.app.stage.scale.x = this.app.stage.scale.y = ratio;
	//	this.app.renderer.resize(window.innerWidth, window.innerHeight); 
	//});

	const bgcolor = 0x111111;
	this.app.renderer.backgroundColor = bgcolor;

	const graphics = new PIXI.Graphics();
	graphics.lineStyle(2, 0x000000, 1);
	graphics.beginFill(bgcolor, 1);
	graphics.drawRect(0, 0, Game.MAPSIZE, Game.MAPSIZE);
	graphics.endFill();
	graphics.beginFill(0x000000, 1);
	for (let i = 0; i < 100; i++) {
		graphics.drawCircle(i % 10 * Math.floor(Game.MAPSIZE / 10), Math.floor(i / 10) * Math.floor(Game.MAPSIZE / 10), 1);
	}
	graphics.endFill();
	this.rendertexture = this.app.renderer.generateTexture(graphics);

	// texture names assignment
	this.playertexture = Game.pixi_loader.resources['assets/player_character.png'].texture;
	this.playeranimationtexture = Game.pixi_loader.resources['assets/player_character_1.png'].texture;
	this.bottletexture = Game.pixi_loader.resources['assets/bottle.png'].texture;
	this.survivalicontexture = Game.pixi_loader.resources['assets/survival_icon.png'].texture;

	this.viewport = new PIXI.Container();
	//this.viewport.scale.set(0.5);
	this.app.stage.addChild(this.viewport);

	this.scene = new PIXI.Container();
	this.scene.scale.set(5);
	this.viewport.addChild(this.scene);

	this.ui = new PIXI.Container();
	this.viewport.addChild(this.ui);

	const background_sprite = new PIXI.Sprite(this.rendertexture);
	this.scene.addChild(background_sprite);

	this.entities = [];

	this.player = this.addEntity(Game.MAPSIZE / 2, Game.MAPSIZE / 2, this.playertexture);

	this.intervals = [];

	this.isPaused = false;

	this.previoustime = Date.now();
	this.intervals.push(setInterval(() => {
		this.gameplay(this.deltatime());
		this.previoustime = Date.now();
	}, 1000 / 30));

	this.viewport.position.set(this.app.renderer.screen.width / 2, this.app.renderer.screen.height / 2);
	this.viewport.pivot = this.viewport.toLocal(this.scene.position, this.player.sprite);

	this.zone1 = document.createElement('div');
	this.zone1.setAttribute('id', 'joystickzone');
	document.body.appendChild(this.zone1);
	this.zone1.addEventListener('contextmenu', function (event) {
		event.preventDefault();
	});
	this.nipplejs = nipplejs.create({mode: 'static', position: {left: '25%', bottom: '50%'}, size: 115, zone: this.zone1, restOpacity: 0.4, color: '#ffffff'});
	this.isjoystickmoving = null;
	this.nipplejs.on('move', (event, data) => {
		//this.isjoystickmoving = {direction: -data.angle.radian, force: Math.min(Math.max(data.force, 0), 1)};
		this.isjoystickmoving = -data.angle.radian;
	});
	this.nipplejs.on('end', (event, data) => {
		this.isjoystickmoving = null;
	});

	this.player.sprite.walkanimationtextures = [this.playertexture, this.playeranimationtexture];

	const gameinstructions = new PIXI.Text('Get water bottles to survive!', new PIXI.TextStyle({
		fontFamily: 'Courier New',
		fontSize: 18,
		fill: '#ffffff',
		stroke: '#000000',
		strokeThickness: 5,
	}));
	gameinstructions.y = -200;
	gameinstructions.anchor.set(0.5);
	this.ui.addChild(gameinstructions);

	const instructionstween = new TWEEN.Tween(gameinstructions.scale)
		.to({x: 1.5, y: 1.5}, 600)
		.repeat(3)
		.yoyo(true)
		.onComplete(() => {
			gameinstructions.destroy();
		})
		.start();

	this.score = 0;
	this.health = 100;

	const barplategraphics = new PIXI.Graphics();
	barplategraphics.lineStyle(4, 0xffffff, 1);
	barplategraphics.beginFill(0x000000, 0.1);
	barplategraphics.drawRect(0, 0, 300, 20);
	barplategraphics.endFill();
	const barplatetexture = this.app.renderer.generateTexture(barplategraphics);
	this.barplate = new PIXI.Sprite(barplatetexture);
	this.barplate.anchor.set(0.5);
	this.barplate.y = 230;
	this.ui.addChild(this.barplate);

	const starvebargraphics = new PIXI.Graphics();
	starvebargraphics.beginFill(0x00aeff, 1);
	starvebargraphics.drawRect(0, 0, 296, 16);
	starvebargraphics.endFill();
	const starvebartexture = this.app.renderer.generateTexture(starvebargraphics);
	this.starvemeter = new PIXI.Sprite(starvebartexture);
	this.starvemeter.position.set(4, 4);
	this.starvemeterfullwidth = 296;
	this.barplate.addChild(this.starvemeter);
	this.starvemeter.position.set(-296 / 2, -16 / 2);

	this.survivalicon = new PIXI.Sprite(this.survivalicontexture);
	this.ui.addChild(this.survivalicon);
	this.survivalicon.anchor.set(-2, 0.5);
	this.survivalicon.x = 265;
	this.survivalicon.y = -195;

	this.scoretext = new PIXI.Text(this.score, new PIXI.TextStyle({
		fontFamily: 'Courier New',
		fontSize: 24,
		fontWeight: 'bold',
		fill: '#ffffff',
		stroke: '#000000',
		strokeThickness: 1,
	}));
	this.scoretext.anchor.set(0, 0.5);
	this.survivalicon.addChild(this.scoretext);

	this.bottlesamount = 0;

	this.intervals.push(setInterval(() => {
		if (!this.isPaused)
			this.createbottle();
	}, 638));

	this.intervals.push(setInterval(() => {
		if (!this.isPaused)
			this.health += -0.5;
	}, 93));

	this.isgameover = false;

	this.app.ticker.add(this.render, this);
};

Game.prototype.render = function(delta) {
	this.viewport.position.set(this.app.renderer.screen.width / 2, this.app.renderer.screen.height / 2);
	const vp = this.viewport.toLocal(this.scene.position, this.player.sprite);
	this.viewport.pivot.set(lerp(this.viewport.pivot.x, vp.x, delta / 50), lerp(this.viewport.pivot.y, vp.y, delta / 50));

	if (!this.isgameover) {
		this.ui.position.copyFrom(this.viewport.pivot);
	}

	this.starvemeter.width = lerp(this.starvemeter.width, this.starvemeterfullwidth * (this.health / 100), delta / 10);
	this.scoretext.text = this.score;

	TWEEN.update();
};

Game.prototype.addEntity = function(x, y, texture, options) {
	const entity = this.makeGameEntity(x, y, texture, options);
	this.entities.push(entity);
	return entity;
};

Game.prototype.removeEntity = function(entity) {
	this.entities.splice(this.entities.indexOf(entity), 1);
	entity.destroy();
};

Game.prototype.makeGameEntity = function(x, y, texture, options) {
	options = options || {};
	const entity = {
		type: options.type || null, // may not be universally needed for all my games. oh, that's why null is there
	};

	const sprite = new PIXI.Sprite(texture);
	sprite.anchor.set(0.5);
	sprite.position.set(x, y);
	sprite.rotation = options.rotation || 0;
	sprite.scale.set(options.scale || 1);
	const spriteParent = options.parent || this.scene;
	spriteParent.addChild(sprite);
	entity.sprite = sprite;

	entity.destroy = function() {
		entity.sprite.destroy();
	};

	entity.run = null; // Code for an entity's behavior that happens every gameplay loop cycle.

	return entity;
};

function lerp(start, end, time) {
	return start * (1 - time) + time * end;
}

function edistance(sprite1, sprite2) {
	const delta1 = sprite2.x - sprite1.x;
	const delta2 = sprite2.y - sprite1.y;
	return Math.sqrt(delta1 * delta1 + delta2 * delta2);
}

Game.prototype.gameplay = function(delta) {
	if (this.health <= 0) {
		this.gameover();
	}
	if (this.isjoystickmoving)
		this.player.sprite.move(this.isjoystickmoving, 1, 1, this.collisiondetection.bind(this));
};

Game.prototype.collisiondetection = function(x, y) {
	this.entities.filter(entity => entity.type === 1).forEach(bottle => {
		if (edistance(bottle.sprite, this.player.sprite) <= 13) {
			bottle.hit();
		}
	});
	if (x > Game.MAPSIZE || y > Game.MAPSIZE || x < 0 || y < 0)
		return true;
};

Game.prototype.deltatime = function() {
	return Date.now() - this.previoustime;
};

Game.prototype.pause = function() {
	this.isPaused = true;
};

Game.prototype.resume = function() {
	this.isPaused = false;
};

Game.prototype.gameover = function () {
	this.isgameover = true;
	this.intervals.forEach(interval_id => {
		clearInterval(interval_id);
	});
	this.nipplejs.destroy();
	document.body.removeChild(this.zone1);
	this.ui.destroy();
	const blurfilter = new PIXI.filters.BlurFilter(15, 10);
	this.app.stage.filters = [blurfilter];

	document.getElementById('score').style.display = 'block';
	document.getElementById('score-text').innerText = 'Score: ' + this.score;
};

Game.prototype.createbottle = function() {
	if (this.bottlesamount === 20)
		return;
	let x, y;
	do {
		x = Math.random() * Game.MAPSIZE;
		y = Math.random() * Game.MAPSIZE;
	} while (edistance(this.player.sprite, {x: x, y: y}) < 50);
	const bottle = this.addEntity(x, y, this.bottletexture, {type: 1, scale: 0.5});
	this.bottlesamount += 1;
	bottle.hit = () => {
		if (this.health <= 90) {
			this.health += 10;
			this.score += 1;
			const plus = new PIXI.Text('+10', new PIXI.TextStyle({
				fontSize: 8,
				fill: '#00aeff',
				fontFamily: 'Courier New',
			}));
			plus.anchor.set(0.5);
			plus.position.copyFrom(bottle.sprite.position);
			this.scene.addChild(plus);
			const plustween = new TWEEN.Tween(plus)
				.to({y: plus.y - 10, alpha: 0}, 400)
				.onComplete(() => {
					plus.destroy();
				})
				.start();
		} else {
			const waste = new PIXI.Text('Too much!', new PIXI.TextStyle({
				fontSize: 8,
				fill: '#ffae00',
				fontFamily: 'Courier New',
			}));
			waste.anchor.set(0.5);
			waste.position.copyFrom(bottle.sprite.position);
			this.scene.addChild(waste);
			const wastetween = new TWEEN.Tween(waste)
				.to({y: waste.y - 10, alpha: 0}, 400)
				.onComplete(() => {
					waste.destroy();
				})
				.start();
		}
		this.bottlesamount += -1;
		this.entities.splice(this.entities.indexOf(bottle), 1);
		const sucktween = new TWEEN.Tween(bottle.sprite)
			.to({x: this.player.sprite.x, y: this.player.sprite.y, alpha: 0}, 300)
			.onComplete(() => {
				bottle.sprite.destroy();
			})
			.start();
	};
};

Game.prototype.mainmenu = function() {
	document.getElementById('score').style.display = 'none';
	document.getElementById('main').style.display = 'block';
};

let game;

document.getElementById('play-button').onpointerup = function() {
	game = new Game();
};

document.getElementById('restart-button').onpointerup = function() {
	game.app.destroy(true);
	game.mainmenu();
	if (!DEBUG && sdk && sdk.showBanner)
		sdk.showBanner();
};

if (!DEBUG) {
	window.SDK_OPTIONS = {
		gameId: "nmpebo8yg5t6jv1v7ifqq2hrl3h4cfsc",
		onEvent: function (a) {
			switch (a.name) {
				case "SDK_GAME_PAUSE":
					// pause game logic / mute audio
					if (game)
						game.pause();
					break;
				case "SDK_GAME_START":
					// advertisement done, resume game logic and unmute audio
					if (game)
						game.resume();
					break;
				case "SDK_READY":
					// when sdk is ready
					break;
			}
		}
	};
	(function (a, b, c) {
		var d = a.getElementsByTagName(b)[0];
		a.getElementById(c) || (a = a.createElement(b), a.id = c, a.src = "https://api.gamemonetize.com/sdk.js", d.parentNode.insertBefore(a, d))
	})(document, "script", "gamemonetize-sdk");

	Game.prototype.onfirstplay = function () {
		if (sdk && sdk.showBanner)
			sdk.showBanner();
	};
}

Game.pixi_load_assets();
